import React, { Fragment, useRef, useState } from "react";
import CloseIcon from "../Assets/Icons/closeIcon.svg";
import AiTeamDropDown from "./AiTeamDropDown";
import UploadIcon from "../Assets/Icons/upload.svg";
import DustBinIcon from "../Assets/Icons/dustBinIcon.svg";
import DescriptiveImg from "../Assets/DescriptiveImg.png";
import PlusIcon from "../Assets/Icons/plusIcon.svg";
import CursorIcon from "../Assets/Icons/cursorIcon.svg";
import { Dialog, Transition } from "@headlessui/react";
import DatePicker from "./DatePicker";
import AllAiDropDown from "./AllAiDropDown";

export default function AllAiProjectsSideBar({ setOpenModal, handleSubmit }) {
  const [open, setOpen] = useState(true);

  const cancelButtonRef = useRef(null);
  return (
    <div
      style={{
        boxShadow:
          "0px 4px 6px 0px rgba(0, 0, 0, 0.05), 0px 10px 15px -3px rgba(0, 0, 0, 0.10)",
      }}
      className="w-[752px] px-3 py-3 bg-white fixed right-0 top-0 z-50 h-screen overflow-y-scroll overflow-x-hidden"
    >
      <div className="flex items-center justify-between">
        <p className="text-[1.1rem] text-[#111928] font-[600]">
          Add AI Project
        </p>
        <button onClick={() => setOpenModal(false)}>
          <img className="cursor-pointer" src={CloseIcon} />
        </button>
      </div>
      <div className="w-full h-[1px] bg-[#D1D5DB] mt-2"></div>
      <div className="flex flex-col gap-5 mt-5">
        <div className="flex items-start flex-col gap-1">
          <label className="text-[0.95rem] text-[#111928] font-[500]">
            AI Project Title
          </label>
          <input
            className="w-[45.5rem] h-[2.6rem] border-[1px] border-[#D1D5DB] bg-[#F9FAFB] text-[0.90rem] text-[#6B7280] pl-3 outline-none rounded-[8px]"
            type="text"
            placeholder="Project Title"
          />
        </div>
        <div className="flex items-start flex-col gap-1">
          <label className="text-[0.95rem] text-[#111928] font-[500]">
            Starting Date
          </label>
          <DatePicker width="45.5rem" />
        </div>
        <div className="flex items-start flex-col gap-1">
          <label className="text-[0.95rem] text-[#111928] font-[500]">
            Completion Date
          </label>
          <DatePicker width="45.5rem" />
        </div>
        <div className="flex items-start flex-col gap-1">
          <label className="text-[0.95rem] text-[#111928] font-[500]">
            Starting Point
          </label>
          <AllAiDropDown text="Ideation" width="45.5rem" />
        </div>
        <div className="flex items-start flex-col gap-1">
          <label className="text-[0.95rem] text-[#111928] font-[500]">
            Beneficiary User
          </label>
          <input
            className="w-[45.5rem] h-[2.6rem] border-[1px] border-[#D1D5DB] bg-[#F9FAFB] text-[0.90rem] text-[#6B7280] pl-3 outline-none rounded-[8px]"
            type="text"
            placeholder="Enter name"
          />
        </div>
        <div>
          <p className="text-[0.95rem] text-[#111928] font-[500]">
            Descriptive Images About the Project 
          </p>
          <div className="flex items-center justify-between mt-1">
            <div className="w-[20.5rem] h-[7.6rem] bg-[#F9FAFB] border-[2px] border-[#E5E7EB] border-dashed rounded-[8px] flex items-center justify-center flex-col gap-2">
              <img src={UploadIcon} />
              <p className="text-[0.95rem] text-[#6B7280]">
                <span className="font-bold">Click to upload</span> or drag and
                drop
              </p>
              <p className="text-[0.80rem] text-[#6B7280]">
                SVG, PNG, JPG or GIF (MAX. 800x400px)
              </p>
            </div>
            <div className="flex items-center gap-3">
              <div
                style={{ backgroundImage: `url(${DescriptiveImg})` }}
                className="w-[7.4rem] h-[7.4rem] bg-cover rounded-[6px]"
              >
                <div className="flex flex-col items-start justify-end h-full p-3 cursor-pointer">
                  <img src={DustBinIcon} />
                </div>
              </div>
              <div
                style={{ backgroundImage: `url(${DescriptiveImg})` }}
                className="w-[7.4rem] h-[7.4rem] bg-cover rounded-[6px]"
              >
                <div className="flex flex-col items-start justify-end h-full p-3 cursor-pointer">
                  <img src={DustBinIcon} />
                </div>
              </div>
              <div
                style={{ backgroundImage: `url(${DescriptiveImg})` }}
                className="w-[7.4rem] h-[7.4rem] bg-cover rounded-[6px]"
              >
                <div className="flex flex-col items-start justify-end h-full p-3 cursor-pointer">
                  <img src={DustBinIcon} />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="flex items-start flex-col gap-1">
          <p className="text-[0.95rem] text-[#111928] font-[500]">
            Share a document describing this project
          </p>
          <div className="w-full h-[7.6rem] bg-[#F9FAFB] border-[2px] border-[#E5E7EB] border-dashed rounded-[8px] flex items-center justify-center flex-col gap-2">
            <img src={UploadIcon} />
            <p className="text-[0.95rem] text-[#6B7280]">
              <span className="font-bold">Click to upload</span> or drag and
              drop
            </p>
            <p className="text-[0.80rem] text-[#6B7280]">
              PDF, PPT, or DOCX (MAX. 5 MB)
            </p>
          </div>
        </div>
        <div className="flex items-start flex-col gap-1">
          <label className="text-[0.95rem] text-[#111928] font-[500]">
            About this AI Project
          </label>
          <textarea
            placeholder="Write description here"
            className="w-[45.5rem] h-[9.6rem] border-[1px] border-[#D1D5DB] bg-[#F9FAFB] text-[0.90rem] text-[#6B7280] pl-3 outline-none rounded-[8px] pt-2 px-2 resize-none"
          ></textarea>
        </div>
        <div className="flex items-start flex-col gap-1">
          <label className="text-[0.95rem] text-[#111928] font-[500]">
            Share a Link to a Description of the Project
          </label>
          <input
            className="w-[45.5rem] h-[2.6rem] border-[1px] border-[#D1D5DB] bg-[#F9FAFB] text-[0.90rem] text-[#6B7280] pl-3 outline-none rounded-[8px] "
            type="text"
            placeholder="Add link"
          />
        </div>
        <div className="flex items-start flex-col gap-1">
          <label className="text-[0.95rem] text-[#111928] font-[500]">
            Problem Description
          </label>
          <textarea
            placeholder="Write problem description here"
            className="w-[45.5rem] h-[9.6rem] border-[1px] border-[#D1D5DB] bg-[#F9FAFB] text-[0.90rem] text-[#6B7280] pl-3 outline-none rounded-[8px] pt-2 px-2 resize-none"
          ></textarea>
        </div>
        <div className="flex items-start flex-col gap-1">
          <label className="text-[0.95rem] text-[#111928] font-[500]">
            MVP Hypothesis
          </label>
          <textarea
            placeholder="Write MVP Hypothesis here"
            className="w-[45.5rem] h-[9.6rem] border-[1px] border-[#D1D5DB] bg-[#F9FAFB] text-[0.90rem] text-[#6B7280] pl-3 outline-none rounded-[8px] pt-2 px-2 resize-none"
          ></textarea>
        </div>
        <div className="flex items-start flex-col gap-1">
          <label className="text-[0.95rem] text-[#111928] font-[500]">
            Impact
          </label>
          <textarea
            placeholder="Write description here"
            className="w-[45.5rem] h-[4.8rem] border-[1px] border-[#D1D5DB] bg-[#F9FAFB] text-[0.90rem] text-[#6B7280] pl-3 outline-none rounded-[8px] pt-2 px-2 resize-none"
          ></textarea>
        </div>
        <div className="flex items-start flex-col gap-1">
          <label className="text-[0.95rem] text-[#111928] font-[500]">
            Share Any Additional Info
          </label>
          <textarea
            placeholder="Write Additional info here"
            className="w-[45.5rem] h-[9.6rem] border-[1px] border-[#D1D5DB] bg-[#F9FAFB] text-[0.90rem] text-[#6B7280] pl-3 outline-none rounded-[8px] pt-2 px-2 resize-none"
          ></textarea>
        </div>
        <div className="flex items-center justify-between">
          <button className="w-[22.3rem] h-[2.5rem] rounded-[8px] text-[0.90rem] text-[#942A27] font-[500] border-[1px] border-[#942A27] flex items-center justify-center gap-2">
            <img src={PlusIcon} />
            Save Project
          </button>
          <button
            className="w-[22.3rem] h-[2.5rem] rounded-[8px] text-[0.90rem] text-white font-[500] border-[1px] border-[#942A27] flex items-center justify-center gap-2 bg-[#942A27]"
            onClick={() => handleSubmit()}
          >
            <img src={CursorIcon} />
            Match AI Team
          </button>
        </div>
      </div>
    </div>
  );
}
